<div class="notification-tile" (click)="navigate()" [attr.data-testid]="notification().id">
  <div class="new-notification" data-testid="new-notification-badge">
    @if (notification().new) {
      <span class="dot"></span>
    }
  </div>

  <div class="notification-image">
    <span class="image">
      <img
        [src]="(notification().imageUrl && (notification().imageUrl | useHttpImgSrc: undefined : true)) || defaultImage"
        data-testid="image" />
    </span>

    <span class="icon {{ notification().priority }}">
      <claas-icon
        [iconId]="notification().cdnIconId"
        namespace="cc"
        [removeDefaultColor]="true"
        [size]="16"
        [attr.data-testid]="'icon-' + notification().priority">
      </claas-icon>
    </span>
  </div>

  <div class="notification-content">
    <span class="title" data-testid="title">{{ notification().title }}</span>
    <span class="text" data-testid="text">{{ notification().text }}</span>
    <span class="footer" data-testid="date">{{ notification().notificationDate | numberToHours }}</span>
  </div>
</div>
